import { defineComponent as _defineComponent } from 'vue'
import { useTranslations } from "@/hooks/useTranslations";


export default /*#__PURE__*/_defineComponent({
  __name: 'EmptyState',
  setup(__props) {

const translations = useTranslations();

return { __sfc: true,translations }
}

})